// extracted by mini-css-extract-plugin
var _1 = "styles-module__appIcon___i1pXB";
var _2 = "styles-module__container___HbisX";
var _3 = "styles-module__desktopText___DVq7B";
var _4 = "styles-module__exploreTitle___Fnp4e";
var _5 = "styles-module__mobileStoreButtons___QfekU";
var _6 = "styles-module__qrCode___m_hvO";
var _7 = "styles-module__title___iBoC2";
export { _1 as "appIcon", _2 as "container", _3 as "desktopText", _4 as "exploreTitle", _5 as "mobileStoreButtons", _6 as "qrCode", _7 as "title" }
